import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import noop from 'lodash-es/noop';

import embedActions from '../actions/embedActions';

import styles from '../styles';

const ArrowControls = props => {
  const goToPreviousSlide = () => {
    props.onMouseEnter();
    if (props.canGoPrevious) {
      props.actions.dispatchPreviousSlide();
    }
  };

  const goToNextSlide = () => {
    props.onMouseEnter();
    if (props.canGoNext) {
      props.actions.dispatchNextSlide();
    }
  };

  // Rubber-band effect
  // http://holko.pl/2014/07/06/inertia-bouncing-rubber-banding-uikit-dynamics/
  const rubber = 0.55;
  const targetDistance = 50;
  const direction = props.swipeDeltaX < 0 ? -1 : 1;
  const delta = Math.abs(props.swipeDeltaX);
  const sourceDistance = props.width;
  const rubberDelta = rubber * delta;
  const offset =
    direction *
    ((targetDistance * rubberDelta) / (sourceDistance + rubberDelta));

  let leftOffset = offset;
  let rightOffset = -offset;

  // Keep offsets negative
  leftOffset = Math.min(leftOffset, 0);
  rightOffset = Math.min(rightOffset, 0);

  const isSwipingLeft = leftOffset < 0;
  const isSwipingRight = rightOffset < 0;

  const arrowStyles = {
    ...styles.arrow,
  };

  const leftArrowStyles = {
    ...arrowStyles,
    justifyContent: 'left',
    display:
      props.visible || (isSwipingLeft && props.visible) ? 'block' : 'none',
    position: 'absolute',
    bottom: '0px',
  };

  let leftArrowControlStyles = {
    ...styles.arrowControl,
    border: '1px solid rgba(255,255,255,0.2)',
    display: `${props.canGoPrevious ? 'block' : 'none'}`,
    margin: '10px',
    left: '0px',
    transform: `translateX(${-leftOffset}px)`,
    transition: 'transform 0.25s ease-out',
    borderRadius: '10px',
    padding: '0.25em',
  };
  // Don't animate transforms for swiping feedback
  if (offset !== 0) {
    leftArrowControlStyles = {
      ...leftArrowControlStyles,
      transition: 'none',
    };
  }

  const rightArrowStyles = {
    ...arrowStyles,
    right: '0px',
    justifyContent: 'right',
    display:
      (props.visible || isSwipingRight) && props.visible ? 'block' : 'none',
    position: 'absolute',
    bottom: '0px',
  };

  let rightArrowControlStyles = {
    ...styles.arrowControl,
    border: '1px solid rgba(255,255,255,0.2)',
    display: `${props.canGoNext ? 'block' : 'none'}`,
    margin: '10px',
    right: '0px',
    transform: `translateX(${rightOffset}px)`,
    transition: 'transform 0.25s ease-out',
    borderRadius: '10px',
    padding: '0.25em',
  };
  // Don't animate transforms for swiping feedback
  if (offset !== 0) {
    rightArrowControlStyles = {
      ...rightArrowControlStyles,
      transition: 'none',
    };
  }

  const arrowIconStyles = {
    ...styles.arrowIcon,
  };

  return (
    <>
      <div style={leftArrowStyles} onClick={goToPreviousSlide}>
        <span style={leftArrowControlStyles} className="bf">
          <i className="icon-arrow_prev_icn" style={arrowIconStyles} />
        </span>
      </div>
      <div style={rightArrowStyles} onClick={goToNextSlide}>
        <span style={rightArrowControlStyles} className="bf">
          <i className="icon-arrow_next_icn" style={arrowIconStyles} />
        </span>
      </div>
    </>
  );
};

ArrowControls.propTypes = {
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
  canGoPrevious: PropTypes.bool.isRequired,
  canGoNext: PropTypes.bool.isRequired,
  swipeDeltaX: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  onMouseEnter: PropTypes.func,
  visible: PropTypes.bool,
};

ArrowControls.defaultProps = {
  onMouseEnter: noop,
  onMouseLeave: noop,
};

const mapStateToProps = state => ({
  canGoPrevious: state.slideReducer.index > 0,
  canGoNext: state.slideReducer.index < state.slideReducer.slides.length - 1,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(embedActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ArrowControls);
